export const commonEditViewMixin = {
    data() {
        return {
            formContext: { 
                editMode: false,
                modal: false,
                item: null
            },
        }
    },

    methods: {
        openEditView(item) {
            this.formContext.editMode = true;
            this.formContext.item = { ...item }
            this.formContext.modal = true
        },
        closeEditView() {
            this.formContext = {
                editMode: false,
                modal: false,
                item: null
            };
        }
    }
}